import { Pipe, PipeTransform } from '@angular/core';
import { Learning_Type } from '@app/enums/learning-type.enum';

@Pipe({
  name: 'instructionTypeIcon',
  standalone: false,
})
export class InstructionTypeIconPipe implements PipeTransform {
  /**
   * Return transformed Learning Type string to show or not show the instruction type icon.
   * @param learningType - instruction type (learning type) to transform to new display type else empty string, if not shown.
   * @returns - transformed instruction (learning type) css name string
   */
  public transform(learningType: string): string {
    switch (learningType) {
      case Learning_Type.INSTRUCTOR_LED:
        return 'virtual';
      case Learning_Type.INSTRUCTOR_LED_IN_PERSON:
      case Learning_Type.IN_PERSON:
        return 'person';
      case Learning_Type.INSTRUCTOR_LED_VIRTUAL:
      case Learning_Type.VIRTUAL:
        return 'virtual';
      case Learning_Type.SELF_STUDY:
        return 'self-study';
      case Learning_Type.WEBINAR:
      case Learning_Type.E_LEARNING:
      case Learning_Type.QUICK_LEARNING:
        return 'eLearning';
      case Learning_Type.CERTIFICATION_EXAM:
        return 'person';
      case Learning_Type.WORKSHOP:
        return 'workshop';
      default:
        return '';
    }
  }
}
